<div class="row" style="margin-top:-14px">
  <div class="col-12 col-md-12">

    <form class="plansform form-container linescrollbar">
      <div class="row">
        <div class="form-group col-12 col-md-12">
          <h6 class="admintitle">{{lang.Add_Employees_to_Health_Wellness_Plans}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>

        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">

          <!-- <div>
    <ul style="display: flex;column-gap: 15px;font-size: 14px;">
      <li>Employee List</li>
      <li>Max Employees: {{maxEmployeeCount}}</li>
      <li>Employee Count: {{lengthofemployee}}</li>
      <li><button id="DownloadButton"  (click)="exportAsXLSX()"><i class="bi bi-download"> </i>&nbsp;Download Template</button></li>
      <li><label for="uploadButton" id="uploadButtonExcel"><i class="bi bi-upload"></i>&nbsp;Upload Employee List<input id="uploadButton" style="display: none" type="file" (change)="onFileChangeExcel($event)" /></label></li>
      <li><button  id="DownloadButton" (click)="addemployee()">+&nbsp;Add</button></li>
    </ul>
  </div> -->
          <div class="table-responsive">
            <table class="table text-nowrap">
              <tr>
                <th>{{lang.Employee_List}}</th>
                <th>{{lang.Max_Employees}}: {{maxEmployeeCount}}</th>
                <th>{{lang.Employee_Count}}: {{lengthofemployee}}</th>
                <th><button id="uploadButtonExcel" (click)="exportAsXLSX()">
                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                  </button></th>
                <th>
                  <label for="uploadButton" id="uploadButtonExcel">
                    <img src="../../../assets/img/upload-employee-list.png" style="width:100px;height:30px">

                    <input id="uploadButton" #myFileInput style="display: none" type="file"
                      (input)="onFileChangeExcel($event)" />
                  </label>

                </th>
                <th><button id="DownloadButton" (click)="addemployee()">+&nbsp;{{lang.Add}}</button></th>
                <div id="output"></div>
                <br>

              </tr>
            </table>
          </div>


        </div>
      </div>
      <div class="row">

        <div class="table-responsive" *ngIf="!isWaddell">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1" id="DataTables_Table_1"
            class="table text-nowrap">
            <thead>
              <tr>
                <th>{{lang.IGBMS_ID}}</th>
                <th>{{lang.Type}}</th>
                <th> {{lang.Name}}</th>
                <!-- <th>Last Name</th> -->
                <th>{{lang.Email}}</th>
                <th>{{lang.Date_of_Hire}}</th>
                <th>{{lang.Prov_of_Employment}}</th>
                <th>{{lang.Status}}</th>
                <th>{{lang.Date_of_Birth}}</th>
                <th>{{lang.Gender}}</th>
                <th>{{lang.Coverage}}</th>
                <!-- <th>Phone No.</th> -->





                <th *ngIf="walletConfigCheck">{{lang.Annual_Income}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let admin of employeeList; let i = index">
                <td class="text-capitalize">{{admin?.fusebillCustomerId || ""}}</td>
                <td>
                  <i *ngIf="admin?.bulkPlanIncluded" class=""
                    style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                    title="Bulk/Group Plan Member">B</i>
                  <i *ngIf="admin?.greenshieldMemberId || admin.greenshieldRegistrationStatus"
                    style="font-size:14px;color:green;font-family: system-ui;font-weight: 600;"
                    title="Greenshield Member">G</i>
                  <i *ngIf="admin?.equitableCertificateId || admin.equitableRegistrationStatu"
                    style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;"
                    title="Equitable Member">E</i>
                </td>
                <td class="text-capitalize">{{admin.firstName}} {{admin.lastName}}</td>
                <!-- <td class="text-capitalize">{{admin.lastName}}</td> -->
                <td>{{admin.email}}</td>
                <td>{{admin.dateOfHire | date:'MM-dd-yyyy'}}</td>
                <td style="text-align: center;">{{admin.province}}</td>
                <td class="text-capitalize">{{admin?.status}}</td>
                <td>{{admin.dateOfBirth | date:'MM-dd-yyyy'}}</td>
                <td class="text-capitalize text-center">{{admin.gender ? admin.gender[0] : ''}}</td>
                <td class="text-capitalize text-center" title="{{admin.maritalStatus}}">
                  {{admin.maritalStatus ? admin.maritalStatus[0]:''}}

                </td>

                <td *ngIf="walletConfigCheck">{{currencySymbol}} {{admin.annualIncome}}</td>

                <td style="display:flex">
                  <a class="btn btn-default editpencil" title="Edit" data-toggle="tooltip"
                    (click)="editemployee(admin,i)"><i class="bi bi-pencil-fill"></i></a>&nbsp;&nbsp;
                  <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                    (click)="deletemployee(admin,i)"><i class="bi bi-trash-fill"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive" *ngIf="isWaddell">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1" id="DataTables_Table_1"
            class="table text-nowrap">
            <thead>
              <tr>
                <th></th>
                <th>{{lang.Name}}</th>
                <th>{{lang.Email}}</th>
                <th>{{lang.Phone_Number}}</th>
                <th>Street Address</th>
                <th>{{lang.Country}}</th>
                <th>{{lang.City}}</th>
                <th>{{lang.Province}}</th>
                <th>{{lang.Postal_Code}}</th>

                <!-- <th>Phone No.</th> -->





                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let admin of employeeList; let i = index">
                <td></td>
                <td class="text-capitalize">{{admin.firstName}} {{admin.lastName}}</td>
                <td>{{admin.email}}</td>
                <td>{{admin.phoneNum}}</td>
                <td>{{admin.streetAddress}}</td>
                <td>{{admin.country}}</td>
                <td>{{admin.city}}</td>
                <td>{{admin.province}}</td>
                <td>{{admin.postalCode}}</td>

                <td style="display:flex">
                  <a class="btn btn-default editpencil" title="Edit" data-toggle="tooltip"
                    (click)="editemployee(admin,i)"><i class="bi bi-pencil-fill"></i></a>&nbsp;&nbsp;
                  <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                    (click)="deletemployee(admin,i)"><i class="bi bi-trash-fill"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>




      </div>

    </form>

    <!-- <div class="row">
        <div class=" text-white text-left">
          <button class="btn btn-primary" id="backbuttonForm"
          type="button" (click)="gotoplansorwalletInfo()" style="float:left"><i aria-hidden="true" class="fa fa-long-arrow-left" ></i>&nbsp;&nbsp;Previous</button>

        </div>
        <div class=" text-white text-right">
          <button class="btn btn-primary" id="basicformSubmit" type="button" (click)="submitEmployeeInfoInfo()"> Save & Next&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right" ></i></button>
        </div>
      </div> -->


    <div class="d-flex justify-content-between" style="padding-top:10px ">
      <button style="margin-bottom: 3px" class="saveAndNext" type="button" (click)="gotoplansorwalletInfo()"><i
          aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;{{lang.Previous}}</button>
      <button style="margin-bottom: 3px; margin-right:5px" class="saveAndNext" type="button"
        (click)="submitEmployeeInfoInfo()">{{lang.Save_Next}}&nbsp;&nbsp;<i aria-hidden="true"
          class="fa fa-long-arrow-right"></i></button>

    </div>

  </div>
</div>


<div class="modal fade" data-bs-backdrop="static" id="addEmployee-modal" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Employee_For_Individual_Plans}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="addbordingform" [formGroup]="addEmployeeformList">


          <div class="row">
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Employee_ID}}</label>

                <input type="text" class="form-control checking-field" id="Employee ID" placeholder={{lang.Employee_ID}}
                  formControlName="employeeId" (keypress)="alphaNumaricssWithHipen($event)" />
                <div *ngIf="emp['employeeId'].touched && emp['employeeId'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeId'].errors && emp['employeeId'].errors['required']">{{lang.Please_enter_Employee_ID}}
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="firstname" placeholder={{lang.First_Name}}
                  (keypress)="alphabatesOnly($event)" formControlName="employeeFirstName" />
                <div *ngIf="emp['employeeFirstName'].touched && emp['employeeFirstName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['required']">{{lang.Please_enter_first_name}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['minlength']">{{lang.First_name_should_be_3_characters}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['maxlength']">
{{lang.First_name_must_not_exceed_20_characters}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['pattern']">First name
                    Shouldn't allow numbers, special characters and blank spaces</div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Last_Name}}
                  (keypress)="alphabatesOnly($event)" formControlName="employeeLastName" />
                <div *ngIf="emp['employeeLastName'].touched && emp['employeeLastName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['required']">{{lang.Please_enter_Last_name}}</div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['minlength']">{{lang.Last_name_should_be_2_characters}}</div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['maxlength']">
                    {{lang.Last_name_must_not_exceed_20_characters}}</div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['pattern']">Last name
                    Shouldn't allow numbers, special characters and blank spaces</div>

                </div>
              </div>
            </div>



            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field text-lowercase" id="email" placeholder={{lang.Email}}
                  formControlName="employeeEmail" (input)="textChangeToLowerCase('employeeEmail')" />
                <div *ngIf="emp['employeeEmail'].touched && emp['employeeEmail'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['required']">{{lang.Please_enter_email}}
                  </div>
                  <div *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['pattern']">{{lang.Please_enter_valid_email}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Hire}}</label>

                <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="employeeDateofhire"
                  bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [minDate]="dateOfHire"
                  (keypress)="numbersOnly($event)" (blur)="checkEmployeeDoh($event)">
                <div *ngIf="emp['employeeDateofhire'].touched && emp['employeeDateofhire'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['required']">{{lang.Please_select_date_of_hire}}
                    </div>
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['pattern']">{{lang.Date_of_hire_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>


                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Phone_Number}}</label>
                <input type="tel" class="form-control checking-field text-lowercase" id="email"
                  placeholder={{lang.Phone_Number}} formControlName="employeePhoneno" (change)="phoneFormat($event)" />
                <div *ngIf="emp['employeePhoneno'].touched && emp['employeePhoneno'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeePhoneno'].errors && emp['employeePhoneno'].errors['required']">{{lang.Please_enter_phone_number}}
                  </div>

                </div>
              </div>

            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Street Address</label>
                <input type="text" class="form-control checking-field text-lowercase" id="Street address"
                  placeholder={{lang.Street_address}} formControlName="employeeStreetAddress" />
                <div *ngIf="emp['employeeStreetAddress'].touched && emp['employeeStreetAddress'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeStreetAddress'].errors && emp['employeeStreetAddress'].errors['required']">
                    {{lang.Please_enter_street_address}}
                  </div>

                </div>
              </div>

            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>
                <!-- <select
                class="form-control"
                id="country"
                formControlName="employeeCountry"
                (change)="getprovincelist($event)">
                <option *ngFor="let country of countryList" [value]="country.name">
                  {{country.name}}
                </option>
              </select> -->
                <!-- <select formControlName="employeeCountry" class="form-control"
                name="mySelect" (change)="getprovincelist($event)" [(ngModel)]="empCountryCanada">
                <option [value]="null" disabled>Select</option>
                 <option *ngFor="let country of countryList" [value]="country.name" >
                  {{country.name}}
                </option>

              </select> -->

                <select class="form-control" id="country" placeholder="country" formControlName="employeeCountry"
                  (change)="getprovincelist($event)">
                  <option [value]="null" disabled>{{lang.Select}}</option>
                  <option *ngFor="let country of countryList" [value]="country.name" selected>
                    {{country.name}}
                  </option>
                </select>


                <div *ngIf="emp['employeeCountry'].touched && emp['employeeCountry'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeCountry'].errors && emp['employeeCountry'].errors['required']">{{lang.Please_select_country}}
                    </div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Postal_Code}}</label>
                <input type="text" class="form-control checking-field" id="Street address"
                  onkeyup="this.value = this.value.toUpperCase();" placeholder={{lang.Postal_Code}}
                  formControlName="employeePostalCode" />
                <div *ngIf="emp['employeePostalCode'].touched && emp['employeePostalCode'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeePostalCode'].errors && emp['employeePostalCode'].errors['required']">
                    {{lang.Please_enter_postal_code}} </div>

                </div>
              </div>
            </div>



            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Province_of_Employment}}<span
                    style="color: red">*</span></label>
                <select class="form-control" id="Province" formControlName="employeeResidence"
                  (change)="provincelist($event)">

                  <option [value]="null" disabled>{{lang.Select}}</option>

                  <option *ngFor="let name of employeeWorkingProviance" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>


                </select>
                <div *ngIf="emp['employeeResidence'].touched && emp['employeeResidence'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeResidence'].errors && emp['employeeResidence'].errors['required']">{{lang.Please_select_Province}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Job_Title}}</label>

                <input type="text" class="form-control checking-field" id="Occupation" placeholder="Job Title"
                  (keypress)="alphabatesOnly($event)" (input)="titleCase($event.target.value)"
                  formControlName="employeeOccupation" />
                <div *ngIf="emp['employeeOccupation'].touched && emp['employeeOccupation'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['required']">{{lang.Please_enter_occupation}}</div>
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['pattern']">{{lang.Job_title_not_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Birth}}</label>

                <input type="text" placeholder="MM-DD-YYYY" class="form-control" formControlName="employeeDateofbirth"
                  bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" (keypress)="numbersOnly($event)"
                  (blur)="checkEmployeeDob($event)">
                <div *ngIf="emp['employeeDateofbirth'].touched && emp['employeeDateofbirth'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['required']">
                    {{lang.Please_select_date_of_hire}}</div>
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['pattern']">{{lang.Date_of_birth_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
                <div class="help-block text-danger"
                  *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['mindateofbirth']">
                  {{lang.Registraion_age_must_be_greater_than_16}}
                </div>
                <div class="help-block text-danger"
                  *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['maxdateofbirth']">
                  {{lang.Registraion_age_must_be_less_than_60}}
                </div>
              </div>
            </div>



            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Gender}}</label>
                <select class="form-control" id="gender" formControlName="employeeGender">

                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Male"> {{lang.Male}} </option>
                  <option value="Female"> {{lang.Female}} </option>
                  <option value="Non-Binary"> {{lang.Non_Binary }}</option>
                  <option value="Undisclosed"> {{lang.Undisclosed }}</option>

                </select>
                <div *ngIf="emp['employeeGender'].touched && emp['employeeGender'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeGender'].errors && emp['employeeGender'].errors['required']">
                    {{lang.Please_select_gender}}</div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Marital_Status}}</label>
                <select class="form-control" id="familyStatus" formControlName="employeefamilyStatus">

                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Single"> {{lang.Single}} </option>
                  <option value="Couple"> {{lang.Couple }}</option>
                  <option value="Family">{{lang.Family}}</option>

                </select>

                <div *ngIf="emp['employeefamilyStatus'].touched && emp['employeefamilyStatus'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeefamilyStatus'].errors && emp['employeefamilyStatus'].errors['required']">
                    {{lang.Please_select_Marital_Status}}</div>
                </div>
              </div>

            </div>





            <div class="col-md-4 col-6" *ngIf="walletConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Annual_Income}}<span *ngIf="walletConfigforemployee"
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="walletlimit" placeholder="Annual Income"
                  formControlName="empployeeAnnualIncome" (keypress)="numberOnly($event)" />
                <div *ngIf="emp['empployeeAnnualIncome'].touched && emp['empployeeAnnualIncome'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['required']">
                    {{lang.Please_enter_annual_income}}</div>
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['pattern']">
                    {{lang.Annual_Income_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>




            <div class="col-md-4 col-6" *ngIf="tierConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Classification Tier<span *ngIf="tierConfigforemployee"
                    style="color: red">*</span></label>
                <select class="form-control" id="employeeTier" placeholder="Select" formControlName="employeeTier">
                  <option [value]="null">{{lang.Select}}</option>
                  <option *ngFor="let name of configureTierList" value={{name.id}}>
                    {{ name.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeTier'].touched && emp['employeeTier'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeTier'].errors && emp['employeeTier'].errors['required']">{{lang.Please_select_tier_configuration}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="submit" class="btn btn-primary" (click)="addemployeetolist()">
          &nbsp;{{lang.Save}}&nbsp;&nbsp;
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<!-- edit employee -->
<div class="modal fade" id="editEmployee-modal" tabindex="-1">
  <div class="modal-dialog model-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Employee}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="addbordingform" [formGroup]="addEmployeeformList">


          <div class="row">
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Employee_ID}}</label>

                <input type="text" class="form-control checking-field" id="Employee ID" placeholder={{lang.Employee_ID}}
                  formControlName="employeeId" [(ngModel)]="editEmployeeId"
                  (keypress)="alphaNumaricssWithHipen($event)" />
                <div *ngIf="emp['employeeId'].touched && emp['employeeId'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeId'].errors && emp['employeeId'].errors['required']">{{lang.Please_enter_Employee_ID}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="firstname"
                  (keypress)="alphabatesOnly($event)" placeholder={{lang.First_Name}} formControlName="employeeFirstName"
                  [(ngModel)]="editEmployeefirstname" />
                <div *ngIf="emp['employeeFirstName'].touched && emp['employeeFirstName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['required']">{{lang.Please_enter_first_name}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['minlength']">{{lang.First_name_should_be_3_characters}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['maxlength']">{{lang.First_name_must_not_exceed_20_characters}}
                    </div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['pattern']">First name
                    Shouldn't allow numbers, special characters and blank spaces</div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Last_Name}}
                  (keypress)="alphabatesOnly($event)" formControlName="employeeLastName"
                  [(ngModel)]="editEmployeelastname" />
                <div *ngIf="emp['employeeLastName'].touched && emp['employeeLastName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['required']">{{lang.Please_enter_Last_name}} </div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['minlength']">{{lang.Last_name_should_be_2_characters}}</div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['maxlength']">{{lang.Last_name_must_not_exceed_20_characters}}
                    </div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['pattern']">last name
                    Shouldn't allow numbers, special characters and blank spaces</div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                  formControlName="employeeEmail" [(ngModel)]="editEmployeeemail"
                  (input)="textChangeToLowerCase('employeeEmail')" />
                <div *ngIf="emp['employeeEmail'].touched && emp['employeeEmail'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['required']">{{lang.Please_enter_email}}
                  </div>
                  <div *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['pattern']">
                    {{lang.Please_enter_valid_email}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Hire}}</label>

                <input type="text" placeholder={{lang.Date_of_Hire}} class="form-control" formControlName="employeeDateofhire"
                  [(ngModel)]="editEmployeeDateofhire" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                  (keypress)="numbersOnly($event)" (blur)="checkEmployeeDoh($event)">

                <div *ngIf="emp['employeeDateofhire'].touched && emp['employeeDateofhire'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['required']">{{lang.Please_select_date_of_hire}}
                    </div>
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['pattern']">{{lang.Date_of_hire_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                  </div>

                </div>
              </div>

            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Phone_Number}}</label>
                <input type="tel" class="form-control checking-field text-lowercase" id="email"
                  placeholder={{lang.Phone_Number}} formControlName="employeePhoneno" [(ngModel)]="editEmployeephone"
                  (change)="phoneFormat($event)" />
                <div *ngIf="emp['employeePhoneno'].touched && emp['employeePhoneno'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeePhoneno'].errors && emp['employeePhoneno'].errors['required']">{{lang.Please_enter_phone_number}}
                  </div>

                </div>
              </div>

            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Street Address</label>
                <input type="text" class="form-control checking-field text-lowercase" id="Street address"
                  [(ngModel)]="editEmployeeStreetAddress" placeholder={{lang.Street_address}} formControlName="employeeStreetAddress" />
                <div *ngIf="emp['employeeStreetAddress'].touched && emp['employeeStreetAddress'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeStreetAddress'].errors && emp['employeeStreetAddress'].errors['required']">
                    {{lang.Please_enter_street_address}}
                  </div>

                </div>
              </div>

            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>
                <select class="form-control" id="country" formControlName="employeeCountry"
                  (change)="getprovincelist($event)" [(ngModel)]="editemployeeCountry">
                  <option [value]="null" disabled>{{lang.Select}}</option>
                  <option *ngFor="let country of countryList" [value]="country.name">
                    {{country.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeCountry'].touched && emp['employeeCountry'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeCountry'].errors && emp['employeeCountry'].errors['required']">{{lang.Please_select_country}}
                    </div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Postal_Code}}</label>
                <input type="text" class="form-control checking-field" id="Street address"
                  onkeyup="this.value = this.value.toUpperCase();" [(ngModel)]="editemployeePostalCode"
                  placeholder={{lang.Postal_Code}} formControlName="employeePostalCode" />
                <div *ngIf="emp['employeePostalCode'].touched && emp['employeePostalCode'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeePostalCode'].errors && emp['employeePostalCode'].errors['required']">{{lang.Please_enter_postal_code}}
                     </div>

                </div>
              </div>
            </div>


            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Province_of_Employment}}<span
                    style="color: red">*</span></label>
                <select class="form-control" id="Province"  formControlName="employeeResidence"
                  (change)="provincelist($event)" [(ngModel)]="editEmployeeResidenetIn">
                  <option [value]="null" disabled>{{lang.Select}}</option>

                  <option *ngFor="let name of employeeWorkingProviance" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>

                <div *ngIf="emp['employeeResidence'].touched && emp['employeeResidence'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeResidence'].errors && emp['employeeResidence'].errors['required']">{{lang.Please_select_Province}}</div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Job_Title}}</label>

                <input type="text" class="form-control checking-field" id="Occupation" placeholder={{lang.Job_Title}}
                  (keypress)="alphabatesOnly($event)" (input)="titleCase($event.target.value)"
                  formControlName="employeeOccupation" [(ngModel)]="editEmployeeOccupation" />
                <div *ngIf="emp['employeeOccupation'].touched && emp['employeeOccupation'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['required']">{{lang.Please_enter_occupation}}
                    </div>
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['pattern']">
                    {{lang.Job_title_not_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Birth}}</label>


                <input type="text" placeholder={{lang.Date_of_Birth}} class="form-control"
                  formControlName="employeeDateofbirth" [(ngModel)]="editEmployeeDateofbirth" bsDatepicker
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" (keypress)="numbersOnly($event)"
                  (blur)="checkEmployeeDob($event)">

                <div *ngIf="emp['employeeDateofbirth'].touched && emp['employeeDateofbirth'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['required']">Please
                    select date of birth</div>
                  <div class="help-block text-danger"
                    *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['mindateofbirth']">
                    {{lang.Registraion_age_must_be_greater_than_16}}
                  </div>
                  <div class="help-block text-danger"
                    *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['maxdateofbirth']">
                    {{lang.Registraion_age_must_be_less_than_60}}
                  </div>
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['pattern']">{{lang.Date_of_birth_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                    </div>

                </div>
              </div>

            </div>



            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Gender}}</label>
                <select class="form-control" id="gender" placeholder="Select" formControlName="employeeGender"
                  [(ngModel)]="editEmployeesex">
                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Male"> {{lang.Male}} </option>
                  <option value="Female"> {{lang.Female}} </option>
                  <option value="Non-Binary"> {{lang.Non_Binary}} </option>
                  <option value="Undisclosed"> {{lang.Undisclosed}} </option>

                </select>
                <div *ngIf="emp['employeeGender'].touched && emp['employeeGender'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeGender'].errors && emp['employeeGender'].errors['required']">
                    {{lang.Please_select_gender}}</div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Marital_Status}}</label>
                <select class="form-control" id="familyStatus" placeholder="Select"
                  formControlName="employeefamilyStatus" [(ngModel)]="editEmployeefamilyStatus">

                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Single"> {{lang.Single}} </option>
                  <option value="Couple"> {{lang.Couple}} </option>
                  <option value="Family">{{lang.Family}}</option>

                </select>
                <div *ngIf="emp['employeefamilyStatus'].touched && emp['employeefamilyStatus'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeefamilyStatus'].errors && emp['employeefamilyStatus'].errors['required']">
                    {{lang.Please_select_Marital_Status}}</div>
                </div>
              </div>
            </div>



            <div class="col-md-4 col-6" *ngIf="walletConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Annual_Income}}<span *ngIf="walletConfigforemployee"
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="walletlimit" (keypress)="numberOnly($event)"
                  placeholder="Annual Income" formControlName="empployeeAnnualIncome"
                  [(ngModel)]="editEmployeeeAnnualIncome" />
                <div *ngIf="emp['empployeeAnnualIncome'].touched && emp['empployeeAnnualIncome'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['required']">
                    {{lang.Please_enter_annual_income}}</div>
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['pattern']">
                    {{lang.Annual_Income_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>

            <div class="col-md-12" *ngIf="tierConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Tier<span *ngIf="tierConfigforemployee"
                    style="color: red">*</span></label>


                <select class="form-control" id="employeeTier" placeholder="Select" formControlName="employeeTier">
                  <option [value]="null">{{lang.Select}}</option>
                  <option *ngFor="let name of configureTierList" value={{name.id}} [(ngModel)]="editEmployeeetier">
                    {{ name.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeTier'].touched && emp['employeeTier'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeTier'].errors && emp['employeeTier'].errors['required']">{{lang.Please_select_tier_configuration}}
                  </div>
                </div>
              </div>
            </div>


          </div>
          <!-- <div class="row" style="margin:0px">
            <div class="col-md-12">
              <button class="btn btn-primary" type="button" (click)="editemployeetolist()"><i class="fa fa-save" ></i>&nbsp;Save&nbsp;&nbsp;</button>

              <button class="btn btn-primary" id="employeeCancelButton" type="button" (click)="editemployeeform()"> Cancel &nbsp;&nbsp;</button>&nbsp;&nbsp;
            </div>
          </div> -->


        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="submit" class="btn btn-primary" (click)="editemployeetolist()">
          &nbsp;{{lang.Save}}&nbsp;&nbsp;
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="existmail-modal" tabindex="-1">
  <div class="modal-dialog model-sm modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Existing Emails</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table>
          <!-- <th>S.no</th> -->
          <th>{{lang.Email}}</th>
          <tr *ngFor="let item of failedEmployeesList;let i=index">
            <!-- <td>{{i+1}}</td> -->
            <td>{{item.mailId}}</td>
          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
